import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'login_or_join',
		path: '/login_or_join',
		component: loadable(async () => import(/* webpackChunkName: "pages/loginOrSignup" */ './index'), {
			exportName: 'LoginOrSignup',
			fallback: Loading,
		}),
		frame: { footer: false, header: true },
		preventCookieWall: true,
		ssr: {
			enabled: true,
			seo: false,
			// This forces a hard navigation when going to /login_or_join, so that an auth state change that happened on another tab
			// can be reflected immediately when the user goes to /login_or_join, which will result in a better user experience
			// as the user won't have to go through the login flow again, or worse, through the signup flow when they already have an account
			// see https://change.slack.com/archives/C038YNYQPUZ/p1778074543868119
			isolated: true,
		},
	},
];
